import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));

export default function CommonSearch({
  className, data, onChange, label, value, disabled,
}) {
  const classes = useStyles();
  return (
    <Autocomplete
      options={data}
      autoHighlight
      blurOnSelect
      onChange={(event, newValue) => {
        onChange(newValue)
      }}
      disabled={disabled}
      value={value}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.text;
      }}
      renderOption={(option) => option.text}
      className={clsx(classes.root, className)}
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
    />
  );
}
